import { render, staticRenderFns } from "./SeparationAnxiety.vue?vue&type=template&id=de983fa8&"
import script from "./SeparationAnxiety.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxiety.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxiety.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports